/**
 * @generated SignedSource<<b3755b9b88b1fc99dc9e7a69f5e9b90d>>
 * @relayHash e8ad3168aec1e3b165488444feeead35
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 770930f72cde42a4dad7f6e065ee4d91985fad47471d9be2db60db37c3f322c6

import type { ConcreteRequest, Query } from 'relay-runtime';
export type uiAiUpsellInEditorFreeModal_GetStartPremiumTrialUrlQuery$variables = {
  cloudId: string;
  offeringKey: string;
  productKey: string;
};
export type uiAiUpsellInEditorFreeModal_GetStartPremiumTrialUrlQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly entitlement: {
        readonly experienceCapabilities: {
          readonly changeOffering: {
            readonly experienceUrl: string | null | undefined;
            readonly isAvailableToUser: boolean | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
};
export type uiAiUpsellInEditorFreeModal_GetStartPremiumTrialUrlQuery = {
  response: uiAiUpsellInEditorFreeModal_GetStartPremiumTrialUrlQuery$data;
  variables: uiAiUpsellInEditorFreeModal_GetStartPremiumTrialUrlQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offeringKey"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productKey"
},
v3 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  },
  {
    "kind": "Literal",
    "name": "hostNames",
    "value": ([]/*: any*/)
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "hamsProductKey",
    "variableName": "productKey"
  }
],
v5 = [
  {
    "kind": "Variable",
    "name": "offeringKey",
    "variableName": "offeringKey"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "isAvailableToUser"
},
v7 = {
  "kind": "ScalarField",
  "name": "experienceUrl"
},
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "uiAiUpsellInEditorFreeModal_GetStartPremiumTrialUrlQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v4/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "experienceCapabilities",
                    "plural": false,
                    "selections": [
                      {
                        "args": (v5/*: any*/),
                        "kind": "LinkedField",
                        "name": "changeOffering",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v7/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "uiAiUpsellInEditorFreeModal_GetStartPremiumTrialUrlQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v4/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "experienceCapabilities",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "args": (v5/*: any*/),
                        "kind": "LinkedField",
                        "name": "changeOffering",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "770930f72cde42a4dad7f6e065ee4d91985fad47471d9be2db60db37c3f322c6",
    "metadata": {},
    "name": "uiAiUpsellInEditorFreeModal_GetStartPremiumTrialUrlQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e5ab6bd5a9e1841e947390e470f12457";

export default node;
